import React, {Component} from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import IconButton from "@mui/material/IconButton";
import {AccountCircle} from "@mui/icons-material";
import {withRouter} from "react-router-dom";
import withStyles from "@mui/styles/withStyles";
import {connect} from "react-redux";
import Typography from "@mui/material/Typography";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import StarIcon from '@mui/icons-material/Star';
import HelpIcon from '@mui/icons-material/Help';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ListIcon from '@mui/icons-material/List';
import ReplyIcon from '@mui/icons-material/Reply';
import CancelIcon from '@mui/icons-material/Cancel';
import SettingsIcon from '@mui/icons-material/Settings';
import HowItWorks from "../Dialogs/HowItWorks";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const styles = (theme) => ({
    root: {
        display: 'flex',
    },
    paper: {
        marginRight: theme.spacing(2),
    },
    userWrapper: {
        padding: "6px 16px 0"
    },
    username: {
        display: "inline"
    },
    userIcon: {
        "vertical-align": "middle",
        marginRight: 15,
        width: 20,
        minWidth: 20
    }
});

class NavbarUserMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            howItWorksOpened: false
        }
    }

    handleToggle(event) {
        if (this.state.anchorEl === null) {
            this.setState({...this.state, anchorEl: event.currentTarget});
        } else {
            this.closeMenu()
        }
    };

    closeMenu() {
        this.setState({...this.state, anchorEl: null});
    };

    handleLogout() {
        this.props.history.push("/logout");
    };


    openHowItWorks = () => {
        this.setState({
            ...this.state,
            howItWorksOpened: true
        });
    };

    closeHowItWorks = () => {
        this.setState({
            ...this.state,
            howItWorksOpened: false
        });
    };

    render() {
        const {classes} = this.props;
        return <>
            <HowItWorks open={this.state.howItWorksOpened} closeHandle={this.closeHowItWorks.bind(this)}/>
            <IconButton
                id="user-menu"
                ref={this.state.anchorEl}
                onClick={this.handleToggle.bind(this)}
                color="inherit"
                size="large">
                <AccountCircle/>
            </IconButton>
            <Popper open={Boolean(this.state.anchorEl)} anchorEl={this.state.anchorEl}
                    style={{zIndex: 1000}}>
                <ClickAwayListener onClickAway={this.closeMenu.bind(this)}>
                    <Paper>
                        <Typography className={classes.userWrapper}>
                            <AccountCircle className={classes.userIcon}/>
                            {this.props.auth.user.first_name} {this.props.auth.user.last_name}
                        </Typography>
                        <MenuList>
                            {this.props.auth.user.email === "admin@voca.click" &&
                                <MenuItem
                                    style={{background: "#ac9701"}}
                                    onClick={() => {
                                        this.props.history.push("/settings");
                                        this.closeMenu();
                                    }}
                                >
                                    <ListItemIcon className={classes.userIcon}>
                                        <SettingsIcon/>
                                    </ListItemIcon>
                                    Settings
                                </MenuItem>}
                            {this.props.auth.user.email === "admin@voca.click" &&
                                <MenuItem
                                    style={{background: "#ac9701"}}
                                    onClick={() => {
                                        this.props.history.push("/coupons");
                                        this.closeMenu();
                                    }}
                                >
                                    <ListItemIcon className={classes.userIcon}>
                                        <ReceiptIcon/>
                                    </ListItemIcon>
                                    Coupons
                                </MenuItem>}
                            {this.props.auth.user.email === "admin@voca.click" &&
                                <MenuItem
                                    style={{background: "#ac9701"}}
                                    onClick={() => {
                                        this.props.history.push("/orders");
                                        this.closeMenu();
                                    }}
                                >
                                    <ListItemIcon className={classes.userIcon}>
                                        <ListIcon/>
                                    </ListItemIcon>
                                    Orders
                                </MenuItem>}
                            <Divider/>
                            <MenuItem
                                onClick={() => {
                                    this.props.history.push("/premium");
                                    this.closeMenu();
                                }}
                            >
                                <ListItemIcon className={classes.userIcon}>
                                    <StarIcon/>
                                </ListItemIcon>
                                Premium
                            </MenuItem>
                            <MenuItem
                                onClick={this.openHowItWorks.bind(this)}
                            >
                                <ListItemIcon className={classes.userIcon}>
                                    <HelpOutlineIcon/>
                                </ListItemIcon>
                                How it works
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    this.props.history.push("/change-password");
                                    this.closeMenu();
                                }}
                            >
                                <ListItemIcon className={classes.userIcon}>
                                    <VpnKeyIcon/>
                                </ListItemIcon>
                                Change password
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    this.props.history.push("/profile-termination");
                                    this.closeMenu();
                                }}
                            >
                                <ListItemIcon className={classes.userIcon}>
                                    <CancelIcon/>
                                </ListItemIcon>
                                Profile termination
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    this.props.history.push("/faq");
                                    this.closeMenu();
                                }}
                            >
                                <ListItemIcon className={classes.userIcon}>
                                    <HelpIcon/>
                                </ListItemIcon>
                                FAQ
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    this.props.history.push("/contact");
                                    this.closeMenu();
                                }}
                            >
                                <ListItemIcon className={classes.userIcon}>
                                    <PermPhoneMsgIcon/>
                                </ListItemIcon>
                                Contact
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    this.props.history.push("/faq/shortcut");
                                    this.closeMenu();
                                }}
                            >
                                <ListItemIcon className={classes.userIcon}>
                                    <ReplyIcon/>
                                </ListItemIcon>
                                Shortcut
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    this.handleLogout();
                                    this.closeMenu();
                                }}
                            >
                                <ListItemIcon className={classes.userIcon}>
                                    <ExitToAppIcon/>
                                </ListItemIcon>
                                Log out
                            </MenuItem>
                        </MenuList>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </>;
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    sessions: state.sessions
});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {}
)(NavbarUserMenu)));
